import React, { useState } from "react";
import { User, Mail, Phone, Briefcase, LogOut } from "lucide-react";
import { useSelector, useDispatch } from "react-redux";
import { StoreState } from "../../models/reduxModels";
import { LogOutAction } from "../../stores/actions/userAction";

const IPhoneUserProfile: React.FC = () => {
  const dispatch = useDispatch();
  const userDetails = useSelector((state: StoreState) => state.user.userDetails);
  const employeeDetail = userDetails?.employee_detail;
  const [imageError, setImageError] = useState<boolean>(false);

  const profileImageUrl =
    userDetails?.imageSingUrl ||
    (employeeDetail as any)?.imageSingUrl ||
    (employeeDetail as any)?.employee_image ||
    "";

  const handleLogout = () => {
    dispatch(LogOutAction() as any);
  };

  return (
    <div className="w-full min-h-screen bg-gray-50 pb-24 text-gray-900 font-sans">
      <div className="p-4 space-y-4 max-w-md mx-auto">
        {/* Profile Card Header */}
        <div className="bg-white rounded-3xl p-6 shadow-sm border border-gray-100 flex flex-col items-center text-center">
          <div className="relative mb-3">
            <div className="w-20 h-20 rounded-full bg-[#FFF3EB] border-2 border-[#FF6B1A] flex items-center justify-center text-[#FF6B1A] font-bold text-2xl shadow-sm overflow-hidden shrink-0">
              {profileImageUrl && !imageError ? (
                <img
                  src={profileImageUrl}
                  alt={employeeDetail?.employee_name || "Profile Photo"}
                  className="w-full h-full object-cover object-center"
                  onError={() => setImageError(true)}
                />
              ) : employeeDetail?.employee_name ? (
                employeeDetail.employee_name.charAt(0).toUpperCase()
              ) : (
                <User className="w-10 h-10" />
              )}
            </div>
            <div className="absolute bottom-0 right-0 w-5 h-5 rounded-full bg-emerald-500 border-2 border-white" />
          </div>

          <h2 className="text-lg font-bold text-gray-900">
            {employeeDetail?.employee_name || userDetails?.userName || "Employee Name"}
          </h2>
          <p className="text-xs font-semibold text-[#FF6B1A] mt-0.5">
            {userDetails?.designation_name || "Designation"}
          </p>
          <span className="mt-2 inline-block px-3 py-1 bg-gray-100 text-gray-600 rounded-full text-[11px] font-mono">
            EMP ID: {employeeDetail?.employee_id || userDetails?.employeeId || "N/A"}
          </span>
        </div>

        {/* Details Card */}
        <div className="bg-white rounded-3xl p-5 shadow-sm border border-gray-100 space-y-4">
          <h3 className="text-xs font-bold text-gray-400 uppercase tracking-wider">
            Personal Information
          </h3>

          <div className="space-y-3 text-xs">
            <div className="flex items-center space-x-3 text-gray-700">
              <div className="w-8 h-8 rounded-xl bg-orange-50 text-[#FF6B1A] flex items-center justify-center shrink-0">
                <Mail className="w-4 h-4" />
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-[10px] text-gray-400 font-medium">Email Address</p>
                <p className="font-semibold text-gray-900 truncate">
                  {employeeDetail?.employee_email || userDetails?.email || "N/A"}
                </p>
              </div>
            </div>

            <div className="flex items-center space-x-3 text-gray-700">
              <div className="w-8 h-8 rounded-xl bg-orange-50 text-[#FF6B1A] flex items-center justify-center shrink-0">
                <Phone className="w-4 h-4" />
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-[10px] text-gray-400 font-medium">Phone Number</p>
                <p className="font-semibold text-gray-900">
                  {employeeDetail?.employee_mob_no || userDetails?.contact || "N/A"}
                </p>
              </div>
            </div>

            {/* <div className="flex items-center space-x-3 text-gray-700">
              <div className="w-8 h-8 rounded-xl bg-orange-50 text-[#FF6B1A] flex items-center justify-center shrink-0">
                <Briefcase className="w-4 h-4" />
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-[10px] text-gray-400 font-medium">Role / User Type</p>
                <p className="font-semibold text-gray-900">
                  {userDetails?.roleType || userDetails?.userType || "Employee"}
                </p>
              </div>
            </div> */}
          </div>
        </div>

        {/* Action Controls */}
        <div className="space-y-2 pt-2">
          <button
            onClick={handleLogout}
            className="w-full py-3.5 px-4 bg-rose-50 hover:bg-rose-100 border border-rose-200 text-rose-600 rounded-2xl text-xs font-bold flex items-center justify-center space-x-2 shadow-sm transition-colors active:scale-[0.98]"
          >
            <LogOut className="w-4 h-4" />
            <span>Sign Out Account</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default IPhoneUserProfile;
